import { Component, Fragment, h, Prop } from '@stencil/core';
import { state } from '@store/product';
import { isOptionMissing, isOptionSoldOut } from '@store/product/getters';
import { __, sprintf } from '@wordpress/i18n';
import { setProduct } from '@store/product/setters';

@Component({
  tag: 'sc-product-pills-variant-option',
  styleUrl: 'sc-product-pills-variant-option.scss',
  shadow: false,
})
export class ScProductPillsVariantOption {
  /** Label */
  @Prop() label: string;

  /** Which option number? */
  @Prop() optionNumber: 1 | 2 | 3 = 1;

  /** The product id */
  @Prop() productId: string;

  render() {
    return (
      <sc-form-control label={this.label}>
        <span slot="label">{this.label}</span>
        <div class="sc-product-pills-variant-option__wrapper">
          {(state[this.productId].variant_options[this.optionNumber - 1].values || []).map(value => {
            const isUnavailable = isOptionSoldOut(this.productId, this.optionNumber, value) || isOptionMissing(this.productId, this.optionNumber, value);
            return (
              <sc-pill-option
                isUnavailable={isUnavailable}
                isSelected={state[this.productId].variantValues[`option_${this.optionNumber}`] === value}
                onClick={() =>
                  setProduct(this.productId, {
                    variantValues: {
                      ...state[this.productId].variantValues,
                      [`option_${this.optionNumber}`]: value,
                    },
                  })
                }
              >
                <span aria-hidden="true">{value}</span>
                <sc-visually-hidden>
                  {sprintf(__('Select %s: %s.', 'surecart'), this.label, value)}
                  {isUnavailable && <Fragment> {__('(option unavailable)', 'surecart')}</Fragment>}
                  {state[this.productId].variantValues[`option_${this.optionNumber}`] === value && <Fragment> {__('This option is currently selected.', 'surecart')}</Fragment>}
                </sc-visually-hidden>
              </sc-pill-option>
            );
          })}
        </div>
      </sc-form-control>
    );
  }
}
